import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const Itemwisesalereortregister = () => {
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const { pathname } = useLocation();
  const [openPrint, setOpenPrint] = useState(false);

  // Form handling using react-hook-form and Yup for validation
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required('From date is required'),
        to_date: Yup.string().required('To date is required')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],  // Default to today
      to_date: new Date().toISOString().split('T')[0],    // Default to today
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

  // Handle date range selection for the report
  const onSubmit = (data) => {
    const { from_date, to_date } = data;
    // Optionally: Make an API call to fetch the report based on the date range
    console.log("Fetching report for", from_date, "to", to_date);
    
    // Trigger the opening of the print window (with the date range included in the URL)
    window.open(
      `/print${pathname}?from_date=${from_date}&to_date=${to_date}`,
      '_blank'
    );
  };

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Item Wise Sale Report Register
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onSubmit)} // Trigger form submission and report generation
                >
                  View Report
                </Button>
                <Button variant="contained" onClick={() => reset()}>
                  Exit
                </Button>
              </Stack>
            </Stack>

            {/* Date Range Form Inputs */}
            <Grid container spacing={2}>
              <Grid item xs={6} md={3}>
                <TextField
                  name="from_date"
                  label="From Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  name="to_date"
                  label="To Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
